export const CLIENT = Object.freeze({
  ID: 'clientId',
  SECRET: 'clientSecret',
});
